import { OnInit, Component, ViewChild } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ExcelService } from '../excel.service';
import { WorkLeaveService } from '../workLeave.service';
import { IDtoWorkLeaveFilter } from 'app/shared/models/request/work-leave/dto-work-leave-filter.model';
import { IDtoWorkLeave } from 'app/shared/models/request/work-leave/dto-work-leave.model';
import { IMyDateModel } from 'angular-mydatepicker';
import { IDtoWorkLeaveChangeStatus } from 'app/shared/models/request/work-leave/dto-work-leave-change-status.model';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { SecurityService } from 'app/shared/services/security.service';
import { saveAs } from 'file-saver';
import { ModalDiscountDismissalComponet } from 'app/views/modales/liquidation/discount/modal-discount-dismissal.component';
import { BsModalService } from 'ngx-bootstrap';
@Component({
    selector: 'app-work-leave-records',
    styleUrls: ['work-leave-records.style.scss'],
    templateUrl: 'work-leave-records.template.html'
})
export class WorkLeaveRecordsComponent implements OnInit {
    /**Formularios */
    private locale: string = 'es';
    private filters = {} as IDtoWorkLeaveFilter;
    /**Notificaciones */
    private listWorkLeaves: IDtoWorkLeave[]
    private listWorkLeavesTemp: IDtoWorkLeave[]
    private search: string;
    private start: IMyDateModel;
    private end: IMyDateModel;
    private changeWorkLeave: IDtoWorkLeaveChangeStatus;
    private workLeave: IDtoWorkLeave;
    private listIds = new Array();
    private showRoles: any;
    private employeeIniId: number;
    private profile: string;
    @ViewChild(DatatableComponent, { static: false }) tableWorkLeave: DatatableComponent;
    @ViewChild('swalCancel', { static: false }) private swalCancel: SwalComponent;
    @ViewChild('swalUpdateList', { static: false }) private swalUpdateList: SwalComponent;
    constructor(private spinner: NgxSpinnerService
        , private workLeaveService: WorkLeaveService
        , private excelService: ExcelService
        , private configGeneral: AppConfig
        , private securityService: SecurityService
        , private modalService: BsModalService) {
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
        }
    }
    ngOnInit(): void {
        this.profile = this.securityService.getProfileStorage('WorkLeaveRecords');
    }

    private getWorkLeavebyFilters(): void {
        this.spinner.show();
        this.filters.startDischargedate = this.getDate(this.start);
        this.filters.endDischargedate = this.getDate(this.end);
        this.filters.employeeId = this.employeeIniId;
        this.filters.profile = this.profile;
        this.workLeaveService.getWorkLeavebyFilters(this.filters).subscribe((res) => {
            if (res.isCorrect) {
                this.listWorkLeaves = res.data as IDtoWorkLeave[];
                this.listWorkLeavesTemp = res.data as IDtoWorkLeave[];
            } else {
                this.configGeneral.newToast('Validación', res.message, 'warning');
            }
            this.spinner.hide();
        });
    }
    generateExcel() {
        if (this.listWorkLeavesTemp != undefined) {
            this.excelService.generateExcelWorkLeave(this.listWorkLeaves);
        }
    }
    generateCsv() {
        if (this.listWorkLeavesTemp != undefined) {
            this.excelService.generateCsv(this.listWorkLeaves);
        }
    }
    private getDate(event?: IMyDateModel) {
        if (event === undefined) {
            return null;
        }
        return event.singleDate.jsDate;
    }
    private cancelWorkLeave(row: IDtoWorkLeave): void {
        this.workLeave = row;
        let a = new Array();
        a.push(this.workLeave.id);
        this.changeWorkLeave = {} as IDtoWorkLeaveChangeStatus;
        this.changeWorkLeave.ids = a;
        this.changeWorkLeave.Status = 1;
        this.swalCancel.title = 'La baja seleccionada será cancelada';
        this.swalCancel.show();
    }
    private updateListWorkLeave(): void {
        this.listIds = new Array();
        this.listWorkLeaves.forEach(element => {
            if (element.statusId == 0) {
                this.listIds.push(element.id);
            }
        });
        if (this.listIds.length > 0) {
            this.swalUpdateList.title = `Se enviarán a baja ${this.listIds.length} registros`;
            this.swalUpdateList.show();
        } else {
            this.configGeneral.newToast('Validación', 'No existen registros para procesar', 'warning');
        }
    }
    private processListWorkLeave(): void {
        this.spinner.show();
        this.workLeaveService.downloadTxt(this.listIds).subscribe((res) => {
            if (res.isCorrect) {
                this.listWorkLeaves.forEach(element => {
                    if (element.statusId == 0) {
                        element.status = 'Completada'
                        element.statusId = 2;
                    }
                });
                this.listWorkLeaves = [...this.listWorkLeaves]
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                this.spinner.hide();
                saveAs(blob, file.fileDownloadName);
            }
            this.spinner.hide();
        });
    }
    private updateWorkLeave(): void {
        this.spinner.show();
        this.workLeaveService.changeWorkLeaveStatus(this.changeWorkLeave).subscribe((res) => {
            if (res.isCorrect) {
                this.workLeave.status = 'Cancelada'
                this.workLeave.statusId = 1;
                this.listWorkLeaves = [...this.listWorkLeaves]
            }
            this.spinner.hide();
        });
    }
    private accessImss(): boolean {
        const profile = this.securityService.getProfileStorage('WorkLeaveRecords');
        return profile === 'IMSS' || profile === 'Auxiliar IMSS'
    }
    private updateFilter() {
        if (this.search === undefined) {
            return;
        }

        const val = this.search.toLowerCase();
        const temp = this.listWorkLeavesTemp.filter((x: any) => x.employeeName.toLowerCase().startsWith(val)
            || x.employeeMarkName.toLowerCase().startsWith(val)
            || x.positionNo.toLowerCase().startsWith(val)
            || x.employeeNum.startsWith(val));
        this.listWorkLeaves = temp;
        this.tableWorkLeave.offset = 0;
    }
    private openModalDiscount(row: IDtoWorkLeave) {
        const initialState = {
          employeeId: row.employeeId,
          requisitionId: row.requisitionId
        };
        this.modalService.show(ModalDiscountDismissalComponet
          , Object.assign({ initialState }
            , { class: 'modal-lg' }
            , this.configGeneral.configModal));
      }
}
